import AbstractRequestTask from "../AbstractRequestTask";
import device from "../../../devices/device";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class LogoutTask extends AbstractRequestTask {
    constructor(params = {}) {
        super();
        this.ownParams = params;
    }

    getParams() {
        const params = super.getParams();
        return Object.assign({}, params, this.ownParams);
    }

    getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");
        return `${http}${url}/services/user/logout`;
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }

}

export default LogoutTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/LogoutTask.js